import { render, staticRenderFns } from "./addMatter.vue?vue&type=template&id=58954843&"
import script from "./addMatter.vue?vue&type=script&lang=js&"
export * from "./addMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports